/**
 * Relative update labels for the portfolio git status badge.
 * < 1 min → just now
 * then: 1 min ago, 2 mins ago, 1 hr ago, 2 hrs ago, 1 day ago, …
 */
export function formatRelativeUpdate(iso, now = Date.now()) {
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return 'recently'

  const diffMs = Math.max(0, now - then)
  const mins = Math.floor(diffMs / 60000)
  const hours = Math.floor(mins / 60)
  const days = Math.floor(hours / 24)
  const months = Math.floor(days / 30)
  const years = Math.floor(days / 365)

  if (mins < 1) return 'just now'
  if (mins === 1) return '1 min ago'
  if (mins < 60) return `${mins} mins ago`
  if (hours === 1) return '1 hr ago'
  if (hours < 24) return `${hours} hrs ago`
  if (days === 1) return '1 day ago'
  if (days < 30) return `${days} days ago`
  if (months === 1) return '1 month ago'
  if (months < 12) return `${months} months ago`
  if (years === 1) return '1 year ago'
  return `${years} years ago`
}

export function formatUpdatedLabel(iso, now = Date.now()) {
  const relative = formatRelativeUpdate(iso, now)
  return relative === 'just now' ? 'Updated just now' : `Updated ${relative}`
}
